"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getIntegerFromUnknown_1 = __importDefault(require("../../shared/getIntegerFromUnknown"));
const rangeIteratorBuilder = () => async ({ functionId, callbacks, executeProcesses, entryVars: { start: inputStart, end: inputEnd, interval: inputInterval, }, }) => {
    const executeError = (error) => executeProcesses(functionId, callbacks.onError, error);
    let start = 0;
    try {
        start = (0, getIntegerFromUnknown_1.default)(inputStart);
    }
    catch (_a) {
        executeError(`Invalid start value: [${start}]`);
        return;
    }
    let end = 0;
    try {
        end = (0, getIntegerFromUnknown_1.default)(inputEnd);
    }
    catch (_b) {
        executeError(`Invalid end value: [${end}]`);
        return;
    }
    if (end < 1) {
        executeError(`Invalid end value: [${end}], should be more than 0`);
        return;
    }
    let interval = 1;
    try {
        interval = (0, getIntegerFromUnknown_1.default)(inputInterval);
    }
    catch (_c) {
        interval = 1;
    }
    if (interval < 1) {
        interval = 1;
    }
    const iterationIndexes = [];
    for (let i = start; i < end; i += interval) {
        await executeProcesses(functionId, callbacks.onIteration, i);
        iterationIndexes.push(i);
    }
    await executeProcesses(functionId, callbacks.onFinish, iterationIndexes);
};
exports.default = rangeIteratorBuilder;
